import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CustomTranslateService } from '../providers/customTranslate.service';

/**
 * Formats the date with appropriate date format based on the current language chosen using the {@link CustomTranslateService}
 */
@Pipe({
  name: 'localizedDatePipe',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translateService: CustomTranslateService) {  }

  transform(value: any, pattern: string = 'fullDate'): any {
    const datePipe: DatePipe = new DatePipe(this.translateService.getCurrentLanguage());
    return datePipe.transform(value, pattern);
  }

}
